module.exports = __webpack_public_path__ + "static/media/minus-gray.17c9a470.svg";